/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */
// eslint-disable-next-line import/order
import React from 'react';

import { Typography } from 'tfc-components';

import Container from 'components/organisms/Container';
import Section from 'components/organisms/Section';

const Banner:React.FC = () => (
  <Section className="p-product_banner">
    <Container>
      <Section.Title white className="p-product_banner_headTitle">
        Our Products
      </Section.Title>
      <Typography.Text fontweight="600" extendClasses="f-20x24 p-product_banner_title">
        AI-native tools built to solve real problems.
      </Typography.Text>

      <Typography.Text extendClasses="f-20x24 p-product_banner_title">
        At EVOL LABS, we don’t build AI for the sake of AI.
        We build products that use AI as the engine — not the decoration — to do what wasn’t possible before.

      </Typography.Text>

      <Typography.Text extendClasses="f-20x24 p-product_banner_title">
        We test fast, kill what doesn’t work, and scale what shows real traction. Here are the products we're actively building and scaling.
      </Typography.Text>
    </Container>

  </Section>
  );

export default Banner;
